export default __webpack_public_path__ + "static/media/add-icon.bf516320.svg";